import React, { useRef, useState } from 'react';
import { FormGroup, Col, Form } from 'react-bootstrap';
import _ from 'lodash';
import RadioButton from '../../../../../components/buttons/RadioButton';
import i18n from 'i18next';
import { useDispatch } from 'react-redux';
import { isTemplate } from '../../../../../utils/miscUtil';
import { mockServicePatchAction } from '../../../../../store/mockServices/mockServiceList/mockServiceListActions';
import { updateMockServiceTemplate } from '../../../../../store/mockServiceTemplates/mockServiceTemplatesActions';
import { CacheType, MockService } from '../../../../../types/rest/mockServiceTypes';
import { format } from 'sql-formatter';
import Button from 'react-bootstrap/Button';
import BzmIcon from '../../../../../components/icons/BzmIcon';

interface Props {
  mockService: MockService;
}

const SqlBootstrapForm = ({ mockService }: Props) => {
  const dispatch = useDispatch();
  const [radioSelected, setRadioSelected] = useState(mockService.cacheType ? mockService.cacheType : 'NO_SQL');
  const [sqlScript, setSqlScript] = useState(mockService.initialSqlScript ? atob(mockService.initialSqlScript) : '');

  const updateCacheType = (radioSelected: CacheType) => {
    const updatedMockService = _.cloneDeep(mockService);
    updatedMockService.cacheType = radioSelected;
    setRadioSelected(radioSelected);
    keepMsUpdated(updatedMockService);
  };

  const updateSqlScript = (sqlString: string) => {
    setSqlScript(sqlString);
    const sm = _.cloneDeep(mockService);
    sm.initialSqlScript = btoa(sqlString);
    keepMsUpdated(sm);
  };

  const keepMsUpdated = useRef(
    _.debounce((sm: MockService) => {
      if (!isTemplate(sm)) {
        dispatch(mockServicePatchAction(sm));
      } else {
        dispatch(updateMockServiceTemplate(sm));
      }
    }, 500),
  ).current;

  const handleFormatSql = () => {
    try {
      const formattedSql = format(sqlScript, { language: 'sql' }); // Formats the SQL script
      setSqlScript(formattedSql);
    } catch (error) {
      console.error('Error formatting SQL:', error);
    }
  };

  return (
    <>
      <FormGroup className={'mb-0'} id={'sqlBootstrap'}>
        <div>
          <RadioButton
            isChecked={radioSelected === 'NO_SQL'}
            id={'keepDefault_id'}
            label={i18n.t('transactions:editor.useNotSql')}
            onChange={() => updateCacheType('NO_SQL')}
          />
        </div>
        <div>
          <RadioButton
            isChecked={radioSelected === 'SQL'}
            id={'boostrapScript_id'}
            label={i18n.t('transactions:editor.useSql')}
            onChange={() => updateCacheType('SQL')}
          />
        </div>
      </FormGroup>
      <Col md={5}>
        <div>
          {radioSelected === 'SQL' && (
            <>
              {/* Format */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '2px' }}>
                <Button
                  onClick={handleFormatSql}
                  variant={'secondary'}
                  size={'sm'}
                  disabled={_.isEmpty(sqlScript)}
                  title={i18n.t('transactions:editor.formatSQL')}
                >
                  <BzmIcon variant={'icon-bzm-timeline'} className={'mr-3 icon-xs align-middle'} />
                  <span className={'align-middle'}>{i18n.t('transactions:editor.formatSQL')}</span>
                </Button>
              </div>
              {/* ./Format */}
              <Form.Control
                as="textarea"
                disabled={false}
                id="qa-textarea-body-content"
                rows={16}
                name="content"
                placeholder={i18n.t('transactions:editor.bodyContentPlaceHolder')}
                onChange={e => updateSqlScript(e.target.value)}
                value={sqlScript}
                isInvalid={false}
              />
            </>
          )}
        </div>
      </Col>
    </>
  );
};

export default SqlBootstrapForm;
